import { useAuth } from "../context/AuthContext";
import { useLocation, Navigate, useNavigate } from "react-router-dom";
import { THEME_COLOR, CLUB_ID } from "../config/club";

export default function SelectMode() {
  const { user, setAppMode } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const THEME_VIOLET = THEME_COLOR;

  if (!user) return <Navigate to="/join" replace />;

  if (user.role !== "queue_master" && !user.clubs?.includes(CLUB_ID)) {
    setAppMode("player");
    return <Navigate to="/join" replace />;
  }

  const handleSelection = (mode) => {
    setAppMode(mode);
    const path = mode === "player" ? "/join" : "/admin/dashboard";
    navigate(`${path}${location.search}`, { replace: true });
  };

  return (
    <div
      className="min-vh-100 d-flex align-items-center justify-content-center p-3"
      style={{ background: "var(--app-bg)" }}
    >
      <div className="w-100" style={{ maxWidth: "450px" }}>

        {/* Branding Section */}
        <div className="text-center mb-5">
          <div className="position-relative d-inline-block">
            <div
              className="position-absolute top-50 start-50 translate-middle w-100 h-100 rounded-circle"
              style={{
                background: THEME_VIOLET,
                opacity: 0.1,
                transform: "scale(1.4)",
                filter: "blur(20px)"
              }}
            ></div>

            <img
              src="/img/rrc.png"
              alt="Logo"
              className="img-fluid rounded-circle shadow-sm position-relative border border-4"
              style={{
                width: "100px",
                height: "100px",
                objectFit: "cover",
                borderColor: "var(--card-bg)"
              }}
            />
          </div>

          <h2
            className="fw-bold mt-4 mb-1"
            style={{ color: "var(--text-color)" }}
          >
            Racket Riot Club
          </h2>

          <p className="small" style={{ color: "var(--muted-text)" }}>
            Welcome back, {user.displayName?.split(" ")[0] || "Admin"}
          </p>
        </div>

        <div className="d-grid gap-3">

          {/* PLAYER MODE CARD */}
          <div
            onClick={() => handleSelection("player")}
            className="p-4 rounded-4 shadow-sm border mode-card"
            style={{
              background: "var(--card-bg)",
              borderColor: "var(--border-color)",
              cursor: "pointer",
              transition: "0.3s"
            }}
          >
            <div className="d-flex align-items-center gap-4">
              <div
                className="rounded-circle d-flex align-items-center justify-content-center"
                style={{
                  width: "60px",
                  height: "60px",
                  background: "var(--surface-bg)"
                }}
              >
                <i
                  className="bi bi-person-bounding-box fs-3"
                  style={{ color: THEME_VIOLET }}
                ></i>
              </div>

              <div className="text-start">
                <h5
                  className="fw-bold mb-0"
                  style={{ color: "var(--text-color)" }}
                >
                  Player Mode
                </h5>
                <p
                  className="small mb-0"
                  style={{ color: "var(--muted-text)" }}
                >
                  Join the queue & view rankings
                </p>
              </div>

              <i
                className="bi bi-chevron-right ms-auto"
                style={{ color: "var(--muted-text)" }}
              ></i>
            </div>
          </div>

          {/* ADMIN MODE CARD */}
          <div
            onClick={() => handleSelection("admin")}
            className="p-4 rounded-4 shadow-sm border mode-card"
            style={{
              background: "var(--card-bg)",
              borderColor: "var(--border-color)",
              borderLeft: `5px solid ${THEME_VIOLET}`,
              cursor: "pointer",
              transition: "0.3s"
            }}
          >
            <div className="d-flex align-items-center gap-4">
              <div
                className="rounded-circle d-flex align-items-center justify-content-center"
                style={{
                  width: "60px",
                  height: "60px",
                  background: `${THEME_VIOLET}15`
                }}
              >
                <i
                  className="bi bi-shield-lock-fill fs-3"
                  style={{ color: THEME_VIOLET }}
                ></i>
              </div>

              <div className="text-start">
                <h5
                  className="fw-bold mb-0"
                  style={{ color: "var(--text-color)" }}
                >
                  Admin Mode
                </h5>
                <p
                  className="small mb-0"
                  style={{ color: "var(--muted-text)" }}
                >
                  Manage queue & match results
                </p>
              </div>

              <i
                className="bi bi-chevron-right ms-auto"
                style={{ color: "var(--muted-text)" }}
              ></i>
            </div>
          </div>
        </div>

        <p
          className="text-center mt-5 small"
          style={{ color: "var(--muted-text)" }}
        >
          Logged in as{" "}
          <strong style={{ color: "var(--text-color)" }}>
            {user.realName || user.displayName}
          </strong>
        </p>
      </div>

      {/* Hover Effect */}
      <style>{`
        .mode-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 12px 24px rgba(0,0,0,0.15) !important;
          border-color: ${THEME_VIOLET} !important;
        }
      `}</style>
    </div>
  );
}